import React, { useState } from "react";
import { Icons } from "../Icons";
import Logo from "./Logo";

const Navbar = ({ page, go }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const links = ["home", "about", "products", "faqs", "contact"];

  return (
    <>
      {/* <div className="topbar">
        <div className="topbar-left">
          <span className="topbar-item">
            <Icons.Globe size={13} color="#fbbf24" />
            <span>Shipping to 50+ countries</span>
          </span>
          <span className="topbar-divider">|</span>
          <span className="topbar-item">
            <Icons.Package size={13} color="#fbbf24" />
            <span>MOQ from 10 units</span>
          </span>
          <span className="topbar-divider">|</span>
          <span className="topbar-item">
            <Icons.Award size={13} color="#fbbf24" />
            <span>ISO 9001 Certified</span>
          </span>
        </div>
        <div className="topbar-right">
          <a
            href="mailto:info@newcoverltd.com"
            className="topbar-link topbar-item"
          >
            <Icons.Mail size={13} color="#fbbf24" />
            <span>info@newcoverltd.com</span>
          </a>
          <span className="topbar-divider">|</span>
          <a href="tel:+18005550199" className="topbar-link topbar-item">
            <Icons.Phone size={13} color="#fbbf24" />
            <span>+1 800 555 0199</span>
          </a>
        </div>
      </div> */}
      <nav className="navbar navbar-glass">
        <div className="nav-inner">
          <Logo
            onClick={() => {
              go("home");
              setMobileOpen(false);
            }}
          />
          <div className="nav-links">
            {links.map((l) => (
              <span
                key={l}
                className={`nav-link${page === l ? " active" : ""}`}
                onClick={() => go(l)}
              >
                {l === "faqs" ? "FAQs" : l[0].toUpperCase() + l.slice(1)}
              </span>
            ))}
          </div>
          <div className="nav-right">
            {/* <div className="nav-phone">
              <Icons.Phone size={14} />
              <span>+1 800 555 0199</span>
            </div> */}
            {/* <button
              className="btn btn-primary btn-sm"
              onClick={() => go("contact")}
            >
              Get a Quote
            </button> */}
            <button
              className="hamburger"
              onClick={() => setMobileOpen((o) => !o)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </nav>
      <div className={`mob-menu${mobileOpen ? " open" : ""}`}>
        {links.map((l) => (
          <span
            key={l}
            className={`mob-link${page === l ? " active" : ""}`}
            onClick={() => {
              go(l);
              setMobileOpen(false);
            }}
          >
            {l === "faqs" ? "FAQs" : l[0].toUpperCase() + l.slice(1)}
          </span>
        ))}
      </div>
    </>
  );
};

export default Navbar;
